// client/src/components/admin/tools/AdminToolPanel.js
// Reusable accordion panel wrapper for admin tools
import PropTypes from 'prop-types'
import ToolOutputDisplay from './ToolOutputDisplay'

/**
 * Reusable accordion panel component
 * @param {object} props - Component props
 * @param {string} props.title - Panel title
 * @param {string} props.subtitle - Panel subtitle
 * @param {boolean} props.isOpen - Whether panel is expanded
 * @param {function} props.onToggle - Callback when header is clicked
 * @param {React.ReactNode} props.children - Panel body content
 * @param {string} props.stdout - Standard output to display
 * @param {string} props.stderr - Standard error to display
 * @param {string} props.message - Message to display in body
 * @param {string} props.variant - Panel color variant (seed, reset, cleanup)
 */
function AdminToolPanel({
  title,
  subtitle,
  isOpen,
  onToggle,
  children,
  stdout,
  stderr,
  message,
  variant = 'seed',
}) {
  return (
    <div className="col-12">
      <div className="accordion-card">
        <button
          className={`accordion-header accordion-header--${variant} ${
            isOpen ? 'is-open' : ''
          }`}
          onClick={onToggle}
          aria-expanded={isOpen}
        >
          <div className="accordion-header-content">
            <h4 className="accordion-title">{title}</h4>
            {subtitle && <p className="accordion-subtitle">{subtitle}</p>}
          </div>
          <span className="accordion-chevron" aria-hidden="true">
            ›
          </span>
        </button>
        {isOpen && (
          <div className="accordion-body">
            {children}
            {message && <div className="small text-muted mb-2">{message}</div>}
          </div>
        )}
        <ToolOutputDisplay stdout={stdout} stderr={stderr} />
      </div>
    </div>
  )
}

AdminToolPanel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
  stdout: PropTypes.string,
  stderr: PropTypes.string,
  message: PropTypes.string,
  variant: PropTypes.oneOf(['seed', 'reset', 'cleanup']),
}

export default AdminToolPanel
